<template>
  <v-card id="confirm-modal" class="main-bg" style="background-color: white">
    <v-toolbar class="elevation-0 white" light max-height="64">
      <v-toolbar-title class="black--text"><h3>{{ title }}</h3></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="onCancel()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-container fluid class="pa-0">
        <v-row>
          <v-col cols="12" md="6">
            <span style="font-size: 16px;" class="label-text">{{ description }}</span>
          </v-col>
        </v-row>
        <v-card-actions class="pr-0 pt-10">
          <v-spacer></v-spacer>
          <v-btn class="mr-2 py-2" x-large depressed outlined height="44" color="primary" @click="onCancel()">ยกเลิก</v-btn>
          <v-btn class="py-2" x-large depressed height="44" color="primary" @click="onSubmit()">ยืนยัน</v-btn>
        </v-card-actions>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  computed: {
  },
  watch: {},
  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
    },
  },
  data() {
    return {
      rules: {
        appointedAtTime: [
          v => !!v || 'กรุณาเลือก เวลานัด',
        ],
      }
    };
  },
  async created() {
    // console.log('data', this.data);
    // await this.$store.dispatch(COMMERCIAL_SERVICE_VENDOR_RATING_REQUEST, this.data.objectId);

    // this.selectedChangedStatus = null;

  },
  methods: {
    onCancel() {
      this.$emit('cancelled');
    },
    onSubmit() {
      this.$emit('saved');
    },
  },
};
</script>
<style lang="scss" scope>
#change-appointment-modal {

}
</style>
